import { useContext } from 'react';

import { AutosaveDraftContext } from 'contexts/AutosaveDraftContext';

export const useAutosaveContext = () => useContext(AutosaveDraftContext)
